<div class="gt-tab-container">
  <li (click)="changeAction('home')" [class.active]="action === 'home'">Home</li>
  <li (click)="changeAction('uploadImg')" [class.active]="action === 'uploadImg'">Profile Settings</li>
</div>

<div class="gt-page-header">
  <h1><i class="fa fa-bell"></i> {{ pageTitle }}</h1>
</div>

@if (action === 'home') {
<div class="gt-page-body">
  <img src="assets/img/setup.jpg" width="100%" />
</div>
}

@if (action === 'uploadImg') {
<div class="gt-page-body">
  <div class="col-md-2">
    <div class="row">
      <div class="profile-wrap">
        <label>
          User Profile_Image:
          <i class="fa fa-info-circle pull-right"></i>
        </label>
        <div>
          <div class="image-wrap">
            <div>
              @if (user?.avatar_path) {
<img
                alt="User1"
                height="100"
                width="100"
               
                [src]="user.avatar_path"
                class="img-responsive"
              />
}
            </div>
          </div>
          @if (user?.avatar_path) {
<button class="btn btn-primary" (click)="removeProfileImage()">
            Remove Image
          </button>
}
          <div class="upload-info">
            <label class="label label-warning">{{ uploadNotImplementedMessage }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-10">
    <h3></h3>
    <p><b>SSO ID:</b> {{ user?.sso_id }}</p>
    <p><b>Name:</b> {{ user?.first_name }} {{ user?.last_name }}</p>
    <p><b>Location:</b> {{ user?.city }} - {{ user?.state }} - {{ user?.country_code }}</p>
    <p><b>Email:</b> <a [href]="'mailto:' + (user?.email || '') + '?Subject=GTW:'" target="_top">{{ user?.email }}</a></p>
    <p><b>Phone:</b> {{ user?.phone }}</p>
    <p><b>Supervisor:</b> {{ user?.supervisor_sso_id }}</p>
  </div>
</div>
}
